/** SASE section types (omnicloud-sase docs/planning/SASE_PLAN.md, SASE-1). */

/** Which sections the console menu shows this account (SD-01): every section,
 *  the SASE section alone (what the SASE edition shows) or every section
 *  except SASE. Stored per account (`users.product_view`). */
export type ProductView = "everything" | "sase_only" | "cloud_only";

export const PRODUCT_VIEWS: readonly ProductView[] = ["everything", "sase_only", "cloud_only"];

export function isProductView(value: unknown): value is ProductView {
  return typeof value === "string" && (PRODUCT_VIEWS as readonly string[]).includes(value);
}

export interface ProductViewUpdate {
  product_view: ProductView;
}

/** One step of the Overview's setup checklist (plan §7.3 Overview).
 *  `done` and `todo` are read from what exists; `later` is a step whose
 *  service is not built on this cloud yet: it says so and links to Get started,
 *  never a made-up figure (SD-17). */
export type ChecklistState = "done" | "todo" | "later";

export interface ChecklistItem {
  key: "sign_in" | "connection" | "policy" | "certificate" | "traffic";
  title: string;
  /** One sentence: what is true now, or what to do. */
  detail: string;
  state: ChecklistState;
  /** Where the step is done (an existing page, or Get started). */
  to: string;
  linkLabel: string;
}
